module.exports = __webpack_public_path__ + "0af4530aba182a75aca446d046d2d0da.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/babystore.png
// module id = 586
// module chunks = 0